<template>
  <SButton
    v-if="parsed.requireTeams"
    variant="link"
    size="sm"
    class="cursor-pointer disabled:cursor-not-allowed"
    data-cy="order-teams-button"
    @click="onClick"
  >
    <span v-if="parsed.teamsStatus === BookingTeamsStatus.Completed">
      {{ $t("completeorder.modify") }}
    </span>

    <span v-else-if="parsed.teamsStatus === BookingTeamsStatus.NotStarted">
      {{ $t("completeorder.add-teams") }}
    </span>

    <span v-else-if="parsed.teamsStatus === BookingTeamsStatus.InProgress">
      {{ $t("completeorder.complete-teams") }}
    </span>
  </SButton>
</template>

<script setup lang="ts">
import { SButton } from "@smeetz/ui-core";

import { openOrderFromTable } from "@/utils/vue-helpers/orders";
import { BookingTeamsStatus } from "@/interfaces/teams/teams";
import type { IParsedOrder } from "@/interfaces/store/IOrder";

import { useParsedRow } from "../../composables/useParsedRow";

const props = defineProps<{ row: Record<string, unknown> }>();

const parsed = useParsedRow(props.row);

/**
 * Open the order in iframe-view with the teams panel pre-selected.
 *
 * @returns {boolean} Sentinel.
 */
function onClick(): boolean {
  openOrderFromTable(props.row as unknown as IParsedOrder, true);

  return true;
}
</script>
